import { Col, Row } from "react-bootstrap";
import { WfsParametersV2 } from "../../../types/Wfs/WfsParametersV2";
import MRNFilters from "./MRNFilters";
import PTFilters from "./PublicTransportFilters";
import OSHighwaysFilters from "./OSHighwaysFilters";

export interface WfsParametersDisplayPropsV2Props {
  areaDescription: string | undefined;
  wfsParameters: WfsParametersV2;
}

const WfsParametersDisplayV2 = ({
  areaDescription,
  wfsParameters,
}: WfsParametersDisplayPropsV2Props) => {
  const renderLayerSpecific = () => {
    switch (wfsParameters.typeName.toLowerCase()) {
      case "os:mrn":
        return <MRNFilters wfsParameters={wfsParameters} />;
      case "basemap:publictransport":
        return <PTFilters wfsParameters={wfsParameters} />;
      case "os:highways":
        return <OSHighwaysFilters wfsParameters={wfsParameters} />;
      default:
        return (
          <>
            {wfsParameters.filter && (
              <Row>
                <Col md="3">Filter</Col>
                <Col md="9" className="text-capitalize">
                  {wfsParameters.filter}
                </Col>
              </Row>
            )}
          </>
        );
    }
  };

  return (
    <>
      <Row>
        <Col md="3">Area</Col>
        <Col md="9" className="text-capitalize">
          {areaDescription}
        </Col>
      </Row>
      {renderLayerSpecific()}
      <Row>
        <Col md="3">Format</Col>
        <Col md="9" className="text-capitalize">
          {wfsParameters.outputFormat}
        </Col>
      </Row>
      {wfsParameters.count && (
        <Row>
          <Col md="3">Count</Col>
          <Col md="9">{wfsParameters.count}</Col>
        </Row>
      )}
      {wfsParameters.startIndex && (
        <Row>
          <Col md="3">Start Index</Col>
          <Col md="9">{wfsParameters.startIndex}</Col>
        </Row>
      )}
      {wfsParameters.sortBy && (
        <Row>
          <Col md="3">Sort By</Col>
          <Col md="9">{wfsParameters.sortBy}</Col>
        </Row>
      )}
      {wfsParameters.srsName && (
        <Row>
          <Col md="3">SRS Name</Col>
          <Col md="9">{wfsParameters.srsName}</Col>
        </Row>
      )}
    </>
  );
};

export default WfsParametersDisplayV2;
